// // import React from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";

// // const DateRangePicker = ({ label, value, onChange, error }) => {
// //   // Convert yyyy-mm-dd → Date object
// //   const parseDate = (str) => (str ? new Date(str) : null);

// //   // Convert Date object → yyyy-mm-dd
// //   const formatToISO = (date) => {
// //     if (!date) return "";
// //     const year = date.getFullYear();
// //     const month = `${date.getMonth() + 1}`.padStart(2, "0");
// //     const day = `${date.getDate()}`.padStart(2, "0");
// //     return `${year}-${month}-${day}`;
// //   };

// //   const handleStartChange = (date) => {
// //     onChange({
// //       start_date: formatToISO(date),
// //       end_date: value?.end_date || "",
// //     });
// //   };

// //   const handleEndChange = (date) => {
// //     onChange({
// //       start_date: value?.start_date || "",
// //       end_date: formatToISO(date),
// //     });
// //   };

// //   return (
// //     <div className="w-full">
// //       {label && (
// //         <label className="block text-sm font-medium text-muted-foreground mb-1">
// //           {label}
// //         </label>
// //       )}

// //       <div className="md:flex items-center gap-2 bg-secondary border border-border rounded-lg p-2">
// //         {/* Start Date */}
// //         <div className="flex flex-col md:w-1/2 relative">
// //           <span className="text-xs text-muted-foreground mb-1">Start</span>
// //           <DatePicker
// //             selected={parseDate(value?.start_date)}
// //             onChange={handleStartChange}
// //             dateFormat="dd/MM/yyyy"
// //             placeholderText="dd/mm/yyyy" 
// //             className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
// //           />
// //           <span className="absolute right-3 top-8 pointer-events-none text-muted-foreground">
// //             📅
// //           </span>
// //         </div>

// //         {/* <div className="text-muted-foreground font-medium">—</div> */}

// //         {/* End Date */}
// //         <div className="flex flex-col md:w-1/2 relative">
// //           <span className="text-xs text-muted-foreground mb-1">End</span>
// //           <DatePicker
// //             selected={parseDate(value?.end_date)}
// //             onChange={handleEndChange}
// //             dateFormat="dd/MM/yyyy"
// //             placeholderText="dd/mm/yyyy"
// //             className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
// //           />
// //           <span className="absolute right-3 top-8 pointer-events-none text-muted-foreground">
// //             📅
// //           </span>
// //         </div>
// //       </div>

// //       {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
// //     </div>
// //   );
// // };

// // export default DateRangePicker;


// // 2 month ka  date set ho start selcect kar raha hai toh automatic 2 month ka  end date set ho jaye and disable ho jaye no change abhle and agar end date select kiya toh automatic start date set ho jaye and disable ho jaye 

// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const DateRangePicker = ({ label, value, onChange, error }) => {
//   // Internal state to track which field is locked
//   const [lockedField, setLockedField] = useState(null); // "start" | "end" | null

//   // Helper functions
//   const parseDate = (str) => (str ? new Date(str) : null);

//   const formatToISO = (date) => {
//     if (!date) return "";
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(20, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // When start date changes
//   const handleStartChange = (date) => {
//     if (!date) {
//       onChange({ start_date: "", end_date: value?.end_date || "" });
//       setLockedField(null);
//       return;
//     }

//     // Set end date = start + 2 months
//     const endDate = new Date(date);
//     endDate.setMonth(endDate.getMonth() + 2);

//     onChange({
//       start_date: formatToISO(date),
//       start_date: formatToISO(date),
//       end_date: formatToISO(endDate),
//     });
//     setLockedField("start"); // Lock end date
//   };

//   // When end date changes
//   // const handleEndChange = (date) => {
//   //   if (!date) {
//   //     onChange({ start_date: value?.start_date || "", end_date: "" });
//   //     setLockedField(null);
//   //     return;
//   //   }

//   //   // Set start date = end - 2 months
//   //   const startDate = new Date(date);
//   //   startDate.setMonth(startDate.getMonth() - 2);

//   //   onChange({
//   //     onChange({
//   //     start_date: formatToISO(startDate),
//   //     end_date: formatToISO(date),
//   //   });
//   //   setLockedField("end"); // Lock start date
//   // });

//   const handleEndChange = (date) => {
//   if (!date) {
//     onChange({ start_date: value?.start_date || "", end_date: "" });
//     setLockedField(null);
//     return;
//   }

//   const startDate = new Date(date);
//   startDate.setMonth(startDate.getMonth() - 2);

//   onChange({
//     start_date: formatToISO(startDate),
//     end_date: formatToISO(date),
//   });

//   setLockedField("end");
// };

//   // Reset lock if parent clears the value externally
//   useEffect(() => {
//     if (!value?.start_date && !value?.end_date) {
//       setLockedField(null);
//     }
//   }, [value]);

//   const isStartDisabled = lockedField === "end";
//   const isEndDisabled = lockedField === "start";

//   return (
//     <div className="w-full">
//       {label && (
//         <label className="block text-sm font-medium text-muted-foreground mb-1">
//           {label}
//         </label>
//       )}

//       <div className="md:flex items-center gap-4 bg-secondary border border-border rounded-lg p-4">
//         {/* Start Date */}
//         <div className="flex flex-col flex-1 relative">
//           <span className="text-xs text-muted-foreground mb-1">
//             Start Date {isStartDisabled && <span className="text-blue-500">(auto)</span>}
//           </span>
//           <DatePicker
//             selected={parseDate(value?.start_date)}
//             onChange={handleStartChange}
//             dateFormat="dd/MM/yyyy"
//             placeholderText="dd/mm/yyyy"
//             className={`w-full rounded-md border ${
//               isStartDisabled ? " cursor-not-allowed opacity-70" : "border-border bg-background"
//             } px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary`}
//           />
//           <span className="absolute right-3 top-8 pointer-events-none text-muted-foreground">   📅</span>
//         </div>

//         <div className="text-center text-muted-foreground my-2">→</div>

//         {/* End Date */}
//         <div className="flex flex-col flex-1 relative">
//           <span className="text-xs text-muted-foreground mb-1">
//             End Date {isEndDisabled && <span className="text-blue-500">(auto)</span>}
//           </span>
//           <DatePicker
//             selected={parseDate(value?.end_date)}
//             onChange={handleEndChange}
//             dateFormat="dd/MM/yyyy"
//             placeholderText="dd/mm/yyyy"
//             className={`w-full rounded-md border ${
//               isEndDisabled ? " cursor-not-allowed opacity-70" : "border-border bg-background"
//             } px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary`}
//           />
//           <span className="absolute right-3 top-8 pointer-events-none text-muted-foreground">   📅</span>
//         </div>
//       </div>

//       {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
//     </div>
//   );
// };

// export default DateRangePicker;

import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRangePicker = ({ condition, label, value, onChange, error: externalError }) => {
  const [internalError, setInternalError] = useState("");

  const parseDate = (str) => (str ? new Date(str) : null);
  const formatToISO = (date) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };

  const addMonths = (date, months) => {
    if (!date) return null;
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    return d;
  };

  const addYears = (date, years) => {
    if (!date) return null;
    const d = new Date(date);
    d.setFullYear(d.getFullYear() + years);
    return d;
  };

  const startDate = parseDate(value?.start_date);
  const endDate = parseDate(value?.end_date);

  // Dynamic limits based on condition
  const isShortRange = condition === true; // true → 2 months, false/null → 3 years
  const maxDurationMonths = isShortRange ? 2 : 36; // 36 months = 3 years
  const maxDurationLabel = isShortRange ? "2 months" : "3 years";

  // Validate range
  useEffect(() => {
    if (startDate && endDate) {
      const maxAllowedEnd = isShortRange 
        ? addMonths(startDate, 2) 
        : addYears(startDate, 3);

      const minAllowedStart = isShortRange
        ? addMonths(endDate, -2)
        : addYears(endDate, -3);

      if (endDate > maxAllowedEnd) {
        setInternalError(`End date cannot be more than ${maxDurationLabel} after start date`);
      } else if (startDate < minAllowedStart) {
        setInternalError(`Start date cannot be more than ${maxDurationLabel} before end date`);
      } else {
        setInternalError("");
      }
    } else {
      setInternalError("");
    }
  }, [startDate, endDate, condition]);

  const handleStartChange = (date) => {
    onChange({
      start_date: formatToISO(date),
      end_date: value?.end_date || "",
    });
  };

  const handleEndChange = (date) => {
    onChange({
      start_date: value?.start_date || "",
      end_date: formatToISO(date),
    });
  };

  const error = internalError || externalError;

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-foreground mb-3">
          {label}
        </label>
      )}

      <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Start Date */}
          <div>
            <label className="text-xs font-medium text-muted-foreground mb-2 block">
              Start Date
            </label>
            <DatePicker
              selected={startDate}
              onChange={handleStartChange}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={endDate || null}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select start date"
              className="w-full px-4 py-3 rounded-lg border border-border bg-background text-sm font-medium 
                         focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary 
                         hover:border-primary/50 transition-all"
            />
          </div>

          {/* End Date */}
          <div>
            <label className="text-xs font-medium text-muted-foreground mb-2 block">
              End Date
            </label>
            <DatePicker
              selected={endDate}
              onChange={handleEndChange}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate || null}
              maxDate={startDate ? (isShortRange ? addMonths(startDate, 2) : addYears(startDate, 3)) : null}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select end date"
              className="w-full px-4 py-3 rounded-lg border border-border bg-background text-sm font-medium 
                         focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary 
                         hover:border-primary/50 transition-all"
            />
          </div>
        </div>

        {/* Dynamic Info */}
        {/* {startDate && endDate && !error && (
          <div className="mt-4 text-center text-xs text-muted-foreground bg-muted/50 rounded-lg py-3 px-4">
            <div>
              Range: <strong>{startDate.toLocaleDateString()}</strong> → <strong>{endDate.toLocaleDateString()}</strong>
            </div>
            <div className="mt-1">
              Duration: {" "}
              <span className="text-success font-medium">
                {Math.round((endDate - startDate) / (1000 * 60 * 60 * 24))} days
              </span>
              {" "} • Max allowed: <strong>{maxDurationLabel}</strong>
            </div>
          </div>
        )} */}

        {/* Error Message */}
        {error && (
          <div className="mt-4 p-4 bg-destructive/10 border border-destructive/50 text-destructive rounded-lg text-sm font-medium text-center">
                         
            <span className="text-xs block mt-2 font-normal opacity-90">
              Maximum allowed duration is {maxDurationLabel}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;